export const API_CONFIG = {
  API_BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  TIMEOUT: 30000,
  USE_MOCK_DATA: false,
};

export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: '/api/auth/login',
    LOGOUT: '/api/auth/logout',
    REFRESH: '/api/auth/refresh',
    VERIFY: '/api/auth/verify',
    REGISTER: '/api/auth/register',
    VERIFY_EMAIL: '/api/auth/verify-email',
    RESEND_VERIFICATION: '/api/auth/resend-verification',
    FORGOT_PASSWORD: '/api/auth/forgot-password',
    RESET_PASSWORD: '/api/auth/reset-password',
    CHALLENGE: '/api/auth/challenge',
  },
  USERS: {
    GET_CURRENT: '/api/users/me',
    UPDATE: '/api/users/update',
    GET_ALL: '/api/users',
    GET_COUNT: '/api/users/count',
    GET_ROLE: '/api/users/:id/role',
    UPDATE_ROLE: '/api/users/:id/role',
  },
  CONFIG: {
    GET_THEME: '/api/config/theme',
    SET_THEME: '/api/config/theme',
    UPLOAD_ASSET: '/api/config/upload-asset',
    FIRST_USER: '/api/config/first-user',
    GET_SETTINGS: '/api/config/settings',
    SET_SETTINGS: '/api/config/settings',
  },
  MESSAGES: {
    SEND: '/api/messages',
    LIST: '/api/messages',
  },
  ADMIN: {
    DASHBOARD: '/api/admin/dashboard',
    UPLOAD_USERS: '/api/admin/upload-users',
    LIST_BATCHES: '/api/admin/batches',
    GET_BATCH: '/api/admin/batches/:id',
    LIST_LENDEES: '/api/admin/lendees',
    GET_LENDEE: '/api/admin/lendees/:id',
    GET_LENDEE_DOCS: '/api/admin/lendees/:id/documents',
    RESEND_INVITE: '/api/admin/lendees/:id/resend-invite',
    SEND_BULK_INVITES: '/api/admin/lendees/send-invites',
    EXPORT_USERS: '/api/admin/export/users',
    LIST_REQUIREMENTS: '/api/admin/document-requirements',
    CREATE_REQUIREMENT: '/api/admin/document-requirements',
    UPDATE_REQUIREMENT: '/api/admin/document-requirements/:id',
    DELETE_REQUIREMENT: '/api/admin/document-requirements/:id',
    VALIDATE_DOCUMENT: '/api/admin/documents/:id/validate',
    LIST_PIPELINES: '/api/admin/pipelines',
    CREATE_PIPELINE: '/api/admin/pipelines',
    GET_PIPELINE: '/api/admin/pipelines/:id',
    UPDATE_PIPELINE: '/api/admin/pipelines/:id',
    DELETE_PIPELINE: '/api/admin/pipelines/:id',
    ASSIGN_PIPELINE: '/api/admin/lendees/:id/pipeline',
    GET_LENDEE_MESSAGES: '/api/admin/lendees/:id/messages',
    SEND_LENDEE_MESSAGE: '/api/admin/lendees/:id/messages',
  },
  LENDEE_DOCUMENTS: {
    UPLOAD: '/api/documents/upload',
    LIST: '/api/documents',
    GET: '/api/documents/:id',
    DELETE: '/api/documents/:id',
    REQUIREMENTS: '/api/documents/requirements',
    CHECKLIST: '/api/documents/checklist',
  },
  ADMIN_USERS: {
    GET_ALL: '/api/users',
    GET_BY_ID: '/api/users/:id',
    UPDATE: '/api/users/:id',
    DELETE: '/api/users/:id',
  },
  AUDIT: {
    GET_LOGS: '/api/audit/logs',
    GET_BY_USER: '/api/audit/logs/user/:userId',
  },
};

export default API_CONFIG;
